import { useState } from "react";
import styles from "./styles.module.scss";

interface Video {
  /** Identyfikator filmu w Vimeo (do podmiany na docelowe ID). */
  id: string;
  title: string;
  description: string;
}

// Filmiki instruktażowe dla poszczególnych typów integracji.
// UWAGA: identyfikatory Vimeo są tymczasowe — do podmiany na docelowe.
const VIDEOS: Video[] = [
  {
    id: "76979871",
    title: "Portal Informacyjny sądów powszechnych",
    description: "Jak skonfigurować integrację z PI i pobierać doręczenia.",
  },
  {
    id: "76979871",
    title: "KSeF — Krajowy System e-Faktur",
    description: "Podłączenie KSeF i obsługa faktur ustrukturyzowanych.",
  },
  {
    id: "76979871",
    title: "Systemy bankowe (PSD2 / PolishAPI)",
    description: "Łączenie rachunków bankowych w standardzie Open Banking.",
  },
  {
    id: "76979871",
    title: "Skrzynka e-mail (Google / Microsoft / IMAP)",
    description: "Dodawanie skrzynki pocztowej i dobór metody integracji.",
  },
  {
    id: "76979871",
    title: "Pakiety biurowe (kalendarze, Google Docs, Office 365)",
    description: "Integracja kalendarzy i edytorów dokumentów.",
  },
];

const IntegrationVideos = () => {
  const [active, setActive] = useState<Video>(VIDEOS[0]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.player}>
        <div className={styles.playerFrame}>
          <iframe
            title={active.title}
            src={`https://player.vimeo.com/video/${active.id}`}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className={styles.playerTitle}>{active.title}</div>
        <div className={styles.playerDesc}>{active.description}</div>
      </div>

      <div className={styles.list}>
        <div className={styles.listTitle}>Filmy instruktażowe</div>
        {VIDEOS.map((video, i) => (
          <div
            key={i}
            className={`${styles.item} ${
              video === active ? styles.itemActive : ""
            }`}
            onClick={() => setActive(video)}
          >
            <div className={styles.itemThumb}>
              <span className={styles.playIcon}>▶</span>
            </div>
            <div className={styles.itemText}>
              <div className={styles.itemTitle}>{video.title}</div>
              <div className={styles.itemDesc}>{video.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationVideos;
